<template>
  <div>
    <h1>Add Site</h1>
    <div class="card mt-3">
      <form @submit.prevent='addSite'>
        <div class="field">
          <label for="abbreviation" class="prompt">Abbreviation: </label>
          <input v-model="newSite.abbreviation" id="abbreviation" placeholder="2 to 4 characters" maxlength="4" style="text-transform:uppercase">
        </div>
        <div class="field">
          <label for="description" class="prompt">Description: </label>
          <input
            type="text"
            id="description"
            name="abbreviation"
            autocomplete="off"
            v-model='newSite.description'
          />
        </div>
        <div>
          <input type="submit" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SiteForm',
  data () {
    return {
      newSite: {
        abbreviation: '',
        description: ''
      }
    }
  },
  computed: {
    ...mapGetters(['sites'])
  },
  methods: {
    addSite () {
      this.newSite.abbreviation = this.newSite.abbreviation.toUpperCase()
      this.$store.dispatch('putSite', this.newSite)
    }
  }
}
</script>

<style scoped>
  .field {
    margin-bottom: 10px;
  }
  .prompt {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
</style>
